var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16270_21852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66894 1.61719H4.00228C3.64866 1.61719 3.30952 1.75766 3.05947 2.00771C2.80942 2.25776 2.66895 2.5969 2.66895 2.95052V13.6172C2.66895 13.9708 2.80942 14.3099 3.05947 14.56C3.30952 14.81 3.64866 14.9505 4.00228 14.9505H12.0023C12.3559 14.9505 12.695 14.81 12.9451 14.56C13.1951 14.3099 13.3356 13.9708 13.3356 13.6172V6.28385M8.66894 1.61719L13.3356 6.28385M8.66894 1.61719V6.28385H13.3356",
    stroke: "#172B4D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16270_21852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.000976562 0.28125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlack);
export default __webpack_public_path__ + "static/media/fileBlack.09ec3acbe869513f14f7c65a2df1325e.svg";
export { ForwardRef as ReactComponent };